import Navbar from "@/components/v2/landing/Navbar";
import HeroSection from "@/components/v2/landing/HeroSection.jsx";
import OurPromiseStrip from "@/components/v2/landing/OurPromiseStrip";
import CategoriesSection from "@/components/v2/landing/CategoriesSection";
import TemplePujaDiscoverySection from "@/components/v2/landing/TemplePujaDiscoverySection";
import NeedHelpStrip from "@/components/v2/landing/NeedHelpStrip";
import TrustSection from "@/components/v2/landing/TrustSection";
import FeaturedPriestsSection from "@/components/v2/landing/FeaturedPriestsSection";
import EnquiryFormSection from "@/components/v2/landing/EnquiryFormSection";
import FAQSection from "@/components/v2/landing/FAQSection";
import FinalCTASection from "@/components/v2/landing/FinalCTASection";
import Footer from "@/components/v2/landing/Footer";
import StickyMobileCTA from "@/components/v2/landing/StickyMobileCTA";
import ExitIntentPopup from "@/components/v2/landing/ExitIntentPopup";
import OrnamentalDivider from "@/components/v2/landing/OrnamentalDivider";
import CredibilityStrip from "@/components/v2/landing/CredibilityStrip";
import LiveBookingFeed from "@/components/v2/landing/LiveBookingFeed";
import Head from "next/head";
import { useEffect } from "react";
import { useRouter } from "next/router";
import { getCookieItem, removeCookieItem } from "@/utils/utils";
import { BACKEND_API_ROUTE, GET_HOME_V2_ROUTE } from "@/commons/api_routes";
import { GETREQUESTAPI } from "@/pages/api/apiUtils";
import SelfBookingSection from '@/components/v2/landing/SelfBookingSection';
import homepageV2Data from "@/data/homepage-v2.json";
import GlobalFestivalStrip, { FestivalStripSpacer } from "@/components/festival/GlobalFestivalStrip";
import FestivalHero from "@/components/festival/FestivalHero";
import { fetchFestivalExperience } from "@/lib/festivalExperience";


// Media and Partner items moved to homepage-v2.json

const Index = ({ homepageData }) => {
  const router = useRouter();

  useEffect(() => {
    window.scrollTo(0, 0);
    const redirectUrl = getCookieItem("redirectUrl");
    if (redirectUrl) {
      removeCookieItem("redirectUrl");
      router.push(redirectUrl);
    }
  }, []);

  const data = homepageData?.body || {};
  const {
    testimonials,
    faq,
    footer,
    generalCategories,
    latestOrders,
    templePujas
  } = data;

  const seoData = homepageV2Data?.seo;
  const siteUrl = process.env.NEXT_PUBLIC_SITE_URL || "https://bookmypoojaonline.com";
  const canonical = `${siteUrl}${router.asPath === "/" ? "" : router.asPath}`;

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": homepageV2Data.seo.structuredData.name,
    "url": siteUrl,
    "logo": `${siteUrl}${homepageV2Data.seo.structuredData.logo}`,
    "description": seoData?.description || homepageV2Data.seo.description,
    "sameAs": homepageV2Data.seo.structuredData.socialLinks,
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": homepageV2Data.seo.structuredData.contactTelephone,
      "contactType": homepageV2Data.seo.structuredData.contactType
    }
  };

  return (
    <>
      <Head>
        <meta
          name="google-site-verification"
          content="Ttzt19k6OKEURdkJsmR_pHJbQPtd3fHL8uatwstkSAk"
        />
        <link rel="canonical" href={canonical} />
        <title>{seoData?.title || "BookMyPooja - Authentic Online Puja Services"}</title>
        <meta name="description" content={seoData?.description || "Book experienced pandit ji for all types of pujas at home or online."} />
        {seoData?.keywords && <meta name="keywords" content={seoData.keywords} />}
        <meta property="og:title" content={seoData?.title || "BookMyPooja"} />
        <meta property="og:description" content={seoData?.description || ""} />
        <meta property="og:url" content={canonical} />
        <meta property="og:type" content="website" />
        {seoData?.ogImage && <meta property="og:image" content={seoData.ogImage} />}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=5" />
        {/* Removed the manual preload tag here because Next.js automatically injects a perfect preload tag for any <Image> with priority={true}. Having a manual preload with an incomplete imageSrcSet was causing the browser to download the image twice on the enquiry page. */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
        />
      </Head>

      <main id="main-content" className="new-v2-theme min-h-screen bg-background pb-16 md:pb-0 font-sans">
          <>
            <Navbar navData={homepageV2Data.navbar} topSlot={<GlobalFestivalStrip />} />
            <FestivalStripSpacer />
            <HeroSection heroData={homepageV2Data.hero} />
            {/* Matches HeroSection's relative offset below the fixed nav */}
            <div className="relative top-20 md:top-10">
              <FestivalHero />
            </div>
            <OurPromiseStrip promiseData={homepageV2Data.promise} />
            <OrnamentalDivider />
            <SelfBookingSection bookingData={homepageV2Data.selfBooking} />
            <CategoriesSection categories={generalCategories} categoriesData={homepageV2Data.categories} />
            <TemplePujaDiscoverySection templePujas={templePujas} />
            <CredibilityStrip label={homepageV2Data.media.label} items={homepageV2Data.media.items} />
            <NeedHelpStrip helpData={homepageV2Data.helpStrip} />
            <TrustSection testimonials={testimonials} trustData={homepageV2Data.trust} />
            <FeaturedPriestsSection priestsData={homepageV2Data.featuredPriests} />
            <OrnamentalDivider />
            <EnquiryFormSection enquiryData={homepageV2Data.enquiry} />
            <CredibilityStrip label={homepageV2Data.partners.label} items={homepageV2Data.partners.items} />
            <OrnamentalDivider />
            <FAQSection items={faq} />
            <FinalCTASection ctaData={homepageV2Data.finalCta} />
            <Footer data={footer} />
            <StickyMobileCTA ctaData={homepageV2Data.stickyMobile} />
            <ExitIntentPopup popupData={homepageV2Data.exitPopup} />
            <LiveBookingFeed latestOrders={latestOrders} />
          </>
      </main>
    </>
  );
};

export const getStaticProps = async () => {
  const url = `${BACKEND_API_ROUTE}${GET_HOME_V2_ROUTE}`;

  try {
    const [response, festivalExperience] = await Promise.all([
      GETREQUESTAPI(url),
      fetchFestivalExperience({ pageType: "home" }),
    ]);
    const homepageData = response.data;
    return { 
      // ISR every 60s also bounds how late a festival switch can appear.
      props: { homepageData, festivalExperience },
      revalidate: 60 // ISR: Revalidate every 60 seconds
    };
  } catch (error) {
    console.error("Error fetching homepage v2 data:", error);
    return { 
      props: { homepageData: null, festivalExperience: await fetchFestivalExperience({ pageType: "home" }) },
      revalidate: 60 
    };
  }
};

export default Index;
